import { useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';

const CAL_ELEMENT_ID = 'eb-cal-inline-demo';

const BookDemoModal = ({ isOpen, onClose }) => {
    const initializedRef = useRef(false);

    useEffect(() => {
        if (!isOpen) return;

        const prevOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';

        (function (C, A, L) {
            const p = function (a, ar) { a.q.push(ar); };
            const d = C.document;
            C.Cal = C.Cal || function () {
                const cal = C.Cal; const ar = arguments;
                if (!cal.loaded) {
                    cal.ns = {};
                    cal.q = cal.q || [];
                    d.head.appendChild(d.createElement('script')).src = A;
                    cal.loaded = true;
                }
                if (ar[0] === L) {
                    const api = function () { p(api, arguments); };
                    const namespace = ar[1];
                    api.q = api.q || [];
                    if (typeof namespace === 'string') {
                        cal.ns[namespace] = cal.ns[namespace] || api;
                        p(cal.ns[namespace], ar);
                        p(cal, ['initNamespace', namespace]);
                    } else p(cal, ar);
                    return;
                }
                p(cal, ar);
            };
        })(window, 'https://app.cal.com/embed/embed.js', 'init');

        window.Cal('init', 'demo', { origin: 'https://app.cal.com' });
        if (!initializedRef.current) {
            window.Cal.ns.demo('inline', {
                elementOrSelector: `#${CAL_ELEMENT_ID}`,
                config: { layout: 'month_view', useSlotsViewOnSmallScreen: 'true' },
                calLink: 'ecombuddha/demo',
            });
            window.Cal.ns.demo('ui', {
                cssVarsPerTheme: {
                    light: { 'cal-brand': '#2766aa' },
                    dark: { 'cal-brand': '#2766aa' },
                },
                hideEventTypeDetails: false,
                layout: 'month_view',
            });
            initializedRef.current = true;
        }

        return () => {
            document.body.style.overflow = prevOverflow;
        };
    }, [isOpen]);

    if (!isOpen) return null;

    return ReactDOM.createPortal(
        <div
            className="fixed inset-0 z-[200] flex items-center justify-center bg-black/50 p-4"
            onClick={onClose}
            role="presentation"
        >
            <div
                className="relative w-[95vw] max-w-[1400px] h-[95vh]"
                onClick={(e) => e.stopPropagation()}
                role="dialog"
                aria-modal="true"
                aria-label="Book a demo"
            >
                <button
                    type="button"
                    onClick={onClose}
                    aria-label="Close"
                    className="absolute top-3 right-3 z-10 w-9 h-9 rounded-full bg-white/90 hover:bg-white text-gray-600 hover:text-gray-900 shadow-md flex items-center justify-center transition-colors"
                >
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </button>
                <div id={CAL_ELEMENT_ID} style={{ width: '100%', height: '100%', overflow: 'auto' }} />
            </div>
        </div>,
        document.body
    );
};

export default BookDemoModal;
